import styled from 'styled-components'

const PStyled = styled.p`
  font-size: 14px;
  font-weight: bold;
`

export default PStyled
